import { Divider as AntDDivider } from "antd";
import React from "react";
type DividerProps = {
  /** Orientation of the Divider: 'left', 'right', or 'center' */
  orientation?: "left" | "right" | "center";
  /** Margin for orientation (in pixels, % or other units) */
  orientationMargin?: string;
  /** Whether the divider is dashed */
  dashed?: boolean;
  /** Plain text style for the divider */
  plain?: boolean;
  /** Content to display on the divider */
  children?: React.ReactNode;
};
const Divider: React.FC<DividerProps> = ({
  orientation = "center",
  orientationMargin,
  dashed = false,
  plain = false,
  children,
}) => {
  return (
    <AntDDivider
      orientation={orientation}
      orientationMargin={orientationMargin}
      dashed={dashed}
      plain={plain}
    >
      {children}
    </AntDDivider>
  );
};
export default Divider;
